export default __webpack_public_path__ + "static/rafiki-1-1cd575364dc69a31867e8b3c592edd6c.png";